import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/EditBlog.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import AgencyNewsContent from "./AgencyNewsContent";

const EditBlog =()=>{
      
 
        const initialFormData = {
            title:'',
            summary: '',
            body: '',
            field_meta_title:'',
            field_meta_keywords:'',
            field_meta_description:'',
            field_blog_preview_text:'',
            field_blog_preview_image:'',
            field_blog_banner_image:'',
            field_delete_blog_preview_image:0,
            field_delete_blog_banner_image:0,
            field_blog_author:'',
            field_blog_author_link:'',
            field_url_restriction:[],
        };
        const [formData,setFormData] =useState(initialFormData);
        const [isLoading, setIsLoading] = useState(true);
        const [toggle, setToggle] = useState(2);
        const [errors, setErrors] = useState({});
        const [tempImagePreview, setTempImagePreview] = useState(null);
        const [tempImageBanner, setTempImageBanner] = useState(null);
        const [imageUploadErrorPreview, setImageUploadErrorPreview] = useState('');
        const [imageUploadErrorBanner, setImageUploadErrorBanner] = useState('');
        const [selectedPreviewImage, setSelectedPreviewImage] = useState(null);
        const [uploadedPreviewImage, setUploadedPreviewImage] = useState(null);
        const [selectedBannerImage, setSelectedBannerImage] = useState(null);
        const [uploadedBannerImage, setUploadedBannerImage] = useState(null);
        const [showSummary, setShowSummary] = useState(false);
        const [useRichEditor, setUseRichEditor] = useState(true);
        const [savedData, setSavedData] = useState(initialFormData);
        const [PreviewFields, setPreviewFields] = useState(false);
        const [viewChanges, setViewChanges] = useState(false);
        const [originalData, setOriginalData] = useState(null);
        const [formDataSnapshot, setFormDataSnapshot] = useState(null);
        const [previewData, setPreviewData] = useState(null);
        const [detailedview, setDetailedView] = useState({});
        const [disabled, setDisabled] = useState(false);
        const [buttontext, setButtonText] = useState("Save");
         const [slug, setSlug] = useState("Save");
        const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
        const [imageState, setImageState] = useState({
            preview: {
              temp: null,
              selected: null,
              error: ''
            },
            banner: {
              temp: null,
              selected: null,
              error: ''
            }
          });




        const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
        const domainName = window.location.hostname;

            const location  = useLocation();
            const drupal_uid = localStorage.getItem('drupal_uid');
            const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
            var loggedin_domain = drupal_domain_url;
            if(localStorage.getItem('loggedin_domain')) {
            loggedin_domain = localStorage.getItem('loggedin_domain');
            } 
            // const {slug} = useParams();
            // var {uid} = useParams();
            // var {username} = useParams();
            // if(location.state) {
            // uid = location.state;
            // }
            const {tab} = useParams();
            const loggedin_uid = localStorage.getItem('uid');
            const navigate = useNavigate();
            const app_url = configData.APP_URL;
            const domain_url = configData.DOMAIN_URL;
            const {id} = useParams();

            function updateToggle(id){
                setToggle(id);
        
                if(id == 1) { 
                //  navigate(`/content/${rid}`);
                 navigate("/blog-content/"+slug);
                }
                if(id == 2) { 
                navigate(
                    "/blog-content/"+id+"/edit"
                );
                }
                
            }

    const getPageTitle = () => {
      const title = originalData?.title || "";

      if (toggle === 1) {
        return title ? title : "Blog Entry";
      } else if (toggle === 2) {
        return title ? `Edit Blog entry ${title}` : "Edit Blog entry";
      }

      return "Edit Blog entry"; // default fallback
    };

    const getPageHeading = () => {
      const title = originalData?.title || "";

      if (toggle === 2) {
        return (
          <>
             Edit Blog entry {title}
          </>
        );
      }

      return null;
    };

    useEffect(() => {
      Promise.all([
        getuserloggedinroles(),
        getblogdetails()
      ]).then(() => {
     
        setIsLoading(false);
        if(tab == "view") {
          setToggle(1);
        }
        if(tab == "edit") {
          setToggle(2);
        }
      })
        
    } ,[tab]);

    async function getuserloggedinroles() {
   
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       
  }      

  async function getblogdetails() {
   
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'smwwblog/getblogdetails?id='+id,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setFormData(responsedata.data.result);
               setSlug(responsedata.data.result.slug);
               setOriginalData(responsedata.data.result);
               setUploadedPreviewImage(responsedata.data.result.field_blog_preview_image);
               setUploadedBannerImage(responsedata.data.result.field_blog_banner_image);
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       
  }      
    
      
      
      const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };
    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };

  

//     const urlOptions = [
//   'www.sportsmanagementworldwide.com',
//   'www.smwwagency.com',
//   'www.smwwscout.com',
// ];
//     const urlOptions = [
//   configData.RSMWW_DOMAIN,
//    configData.RSMWW_AGENCY_DOMAIN,
//    configData.RSMWW_SCOUT_DOMAIN,
// ];
  const urlRestriction = [
    {value: configData.RSMWW_DOMAIN, label: "SportsManagementWorldwide.com"},
    {value: configData.RSMWW_AGENCY_DOMAIN, label: "SMWWAgency.com"},
    {value: configData.RSMWW_SCOUT_DOMAIN, label: "SMWWScout.com"}
  ]


const handlePreviewClick = () => {
  setViewChanges(false);
  const {
     title,
     summary,
     body,
     field_meta_title,
     field_meta_keywords,
     field_meta_description,
     field_blog_preview_text,
     field_blog_preview_image,
     field_blog_banner_image,
     field_blog_author,
     field_blog_author_link,
     field_url_restriction,
  } = formData;


  const newErrors = {};
  if (!title.trim()) {
    newErrors.title = "Title field is required.";
  }
 

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    setPreviewFields(false);
    return;
  }
  const bodyHtml = body || '';
  const hasSummary = summary && summary.trim() !== '';
  let trimmedHtml = '';

  if (hasSummary) {
  trimmedHtml = summary;
} else if (bodyHtml.includes('<!--break-->')) {
  trimmedHtml = bodyHtml.split('<!--break-->')[0];
} else {
  const tmp = document.createElement('div');
  tmp.innerHTML = bodyHtml;
  const plainText = (tmp.textContent || tmp.innerText || "").trim();

 trimmedHtml = '';
}

 

  setPreviewData({
    title,
    summary: hasSummary ? summary : '',
    body: bodyHtml,
    trimmed: trimmedHtml,  
    field_meta_title,
    field_meta_keywords,
    field_meta_description,
    field_blog_preview_text,
    field_blog_preview_image,
    field_blog_banner_image,
    field_blog_author,
    field_blog_author_link,      
    field_url_restriction: Array.isArray(field_url_restriction) &&
        field_url_restriction.length === 0
        ? ''
        : field_url_restriction,
  });
  window.scrollTo(0, 0);
  setErrors({});
  setPreviewFields(true);  
};
const handleViewChangesClick = () => {
  setPreviewFields(false);
  const newErrors = {};

  if (!formData.title.trim()) {
    newErrors.title = 'Title field is required.';
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).some(key => newErrors[key])) {
    setViewChanges(false); // Don't show view changes
    return;
  }

  setViewChanges(true);
  



setFormDataSnapshot({
  ...formData,

});

  setOriginalData(prev => ({
    ...prev,
   
  }));

  window.scrollTo(0, 0);
};

const normalizeArray = (arr = []) =>
  Array.isArray(arr) ? arr.join(', ') : '';

    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;


        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };
      

    const getFileIcon = (fileName) => {
          if (!fileName || typeof fileName !== 'string') {
      return '/images/image-x-generic.png';
    }
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const maxSize = 128 * 1024 * 1024;

 const getFileName = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    return value.split("/").pop(); // extract filename from URL
  }
  if (value.name) return value.name; // File object or wrapper with .name
  if (value.file && value.file.name) return value.file.name; // wrapper {file, preview, name}
  return "";
};
const getImageSrc = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value; // already a URL from backend
  if (value.preview) return value.preview; // wrapper object { file, preview, name }
  if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
  if (value instanceof File) return URL.createObjectURL(value); // plain File object
  return "";
};
const getLabels = (values) => {
  if (!values || !Array.isArray(values)) return [];
  return values.map(val => {
    const option = urlRestriction.find(opt => opt.value === val);
    return option ? option.label : val; // Fallback to value if label not found
  });
};

// const handleTempImageChange = (e, type) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
//   const maxSize = 128 * 1024 * 1024; // 128 MB
//   const errors = [];

//   if (!validTypes.includes(file.type)) {
//     errors.push('Allowed file types: png, gif, jpg, jpeg.');
//   }

//   if (file.size > maxSize) {
//     errors.push('File must be less than 128 MB.');
//   }

//   if (errors.length > 0) {
//     const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;

//     if (type === 'preview') {
//       setImageUploadErrorPreview(errorHTML);
//       setTempImagePreview(null);
//     } else {
//       setImageUploadErrorBanner(errorHTML);
//       setTempImageBanner(null);
//     }

//     e.target.value = '';
//     return;
//   }

//   // clear errors
//   if (type === 'preview') {
//     setImageUploadErrorPreview('');
//     setTempImagePreview({ file });
//   } else {
//     setImageUploadErrorBanner('');
//     setTempImageBanner({ file });
//   }
// };
const handleTempImageChange = (e, type) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const maxSize = 128 * 1024 * 1024; // 128 MB

  // ---------- File type & size validation ----------
  if (!validTypes.includes(file.type)) {
    const errorHTML = `
      The selected file <em>${file.name}</em> cannot be uploaded.<br/>
      Only files with the following extensions are allowed:
      <em>png, gif, jpg, jpeg</em>.
    `;

    if (type === 'preview') {
      setImageUploadErrorPreview(errorHTML);
      setTempImagePreview(null);
    } else {
      setImageUploadErrorBanner(errorHTML);
      setTempImageBanner(null);
    }

    e.target.value = '';
    return;
  }

  if (file.size > maxSize) {
    const errorHTML = `
      The selected file <em>${file.name}</em> cannot be uploaded.<br/>
      File must be less than <em>128 MB</em>.
    `;

    if (type === 'preview') {
      setImageUploadErrorPreview(errorHTML);
      setTempImagePreview(null);
    } else {
      setImageUploadErrorBanner(errorHTML);
      setTempImageBanner(null);
    }

    e.target.value = '';
    return;
  }

  // ---------- Image dimension validation ----------
  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = () => {
    const width = img.width;
    const height = img.height;
    let errorHTML = '';

    if (type === 'preview') {
      // EXACT: 448 x 220
      if (width !== 448 || height !== 220) {
        errorHTML = `
          The selected file <em>${file.name}</em> cannot be uploaded. Preview image size must be <em>448 × 220 px</em>.
        `;
      }
    } else {
      // MIN: 850 x 439 | MAX: 1120 x 553
      if (
        width < 850 ||
        height < 439 ||
        width > 1120 ||
        height > 553
      ) {
        errorHTML = `
          The selected file <em>${file.name}</em> cannot be uploaded. Banner image size must be between <em>850 × 439 px</em> and <em>1120 × 553 px</em>.
        `;
      }
    }

    URL.revokeObjectURL(objectUrl);

    // ---------- Dimension error ----------
    if (errorHTML) {
      if (type === 'preview') {
        setImageUploadErrorPreview(errorHTML);
        setTempImagePreview(null);
      } else {
        setImageUploadErrorBanner(errorHTML);
        setTempImageBanner(null);
      }

      e.target.value = '';
      return;
    }

    // ---------- SUCCESS ----------
    if (type === 'preview') {
      setImageUploadErrorPreview('');
      setTempImagePreview({ file });
    } else {
      setImageUploadErrorBanner('');
      setTempImageBanner({ file });
    }
  };

  img.onerror = () => {
    URL.revokeObjectURL(objectUrl);

    const errorHTML = `
      The selected file <em>${file.name}</em> cannot be uploaded.<br/>
      Invalid image file.
    `;

    if (type === 'preview') {
      setImageUploadErrorPreview(errorHTML);
      setTempImagePreview(null);
    } else {
      setImageUploadErrorBanner(errorHTML);
      setTempImageBanner(null);
    }

    e.target.value = '';
  };

  img.src = objectUrl;
};

const handleImageUploadClick = (type) => {
  const tempImage = type === 'preview' ? tempImagePreview : tempImageBanner;

  if (tempImage?.file) {
    const objectUrl = URL.createObjectURL(tempImage.file);

    if (type === 'preview') {
      setSelectedPreviewImage({
        file: tempImage.file,
        preview: objectUrl
      });

      setFormData(prev => ({
        ...prev,
        field_blog_preview_image: tempImage.file,
        field_delete_blog_preview_image: 0
      }));

      setImageUploadErrorPreview('');
    } else {
      setSelectedBannerImage({
        file: tempImage.file,
        preview: objectUrl
      });

      setFormData(prev => ({
        ...prev,
        field_blog_banner_image: tempImage.file,
        field_delete_blog_banner_image: 0
      }));

      setImageUploadErrorBanner('');
    }
  }
};

 const handleRemoveSavedImage = (type) => {
  if (type === 'preview') {
    setFormData(prev => ({
      ...prev,
      field_blog_preview_image: '',
      field_delete_blog_preview_image: 1
    }));
    setSelectedPreviewImage(null);
    setTempImagePreview(null);
    setImageUploadErrorPreview('');
  } else {
    setFormData(prev => ({
      ...prev,
      field_blog_banner_image: '',
      field_delete_blog_banner_image: 1
    }));
    setSelectedBannerImage(null);
    setTempImageBanner(null);
    setImageUploadErrorBanner('');
  }
};

const handleRemoveSelectedImage = (type) => {
  if (type === 'preview') {
    setSelectedPreviewImage(null);
    setTempImagePreview(null);
    setImageUploadErrorPreview('');
    setFormData(prev => ({
      ...prev,
      field_blog_preview_image: '',
      field_delete_blog_preview_image: 0
    }));
  } else {
    setSelectedBannerImage(null);
    setTempImageBanner(null);
    setImageUploadErrorBanner('');
    setFormData(prev => ({
      ...prev,
      field_blog_banner_image: '',
      field_delete_blog_banner_image: 0
    }));
  }
};


 const formatFileSize = (size) => {
    if (size < 1024) return size + " Bytes";
    else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
    else return (size / (1024 * 1024)).toFixed(2) + " MB";
  };
const previewImageValue =
  selectedPreviewImage
    ? selectedPreviewImage.file
    : formData.field_blog_preview_image?.name;

let previewFileName = '';

if (previewImageValue instanceof File) {
  previewFileName = previewImageValue.name;
} else if (typeof previewImageValue === 'string') {
  previewFileName = previewImageValue.split('/').pop();
}
const bannerImageValue =
  selectedBannerImage
    ? selectedBannerImage.file
    : formData.field_blog_banner_image?.name;

let bannerFileName = '';

if (bannerImageValue instanceof File) {
  bannerFileName = bannerImageValue.name;
} else if (typeof bannerImageValue === 'string') {
  bannerFileName = bannerImageValue.split('/').pop();
}

        
            const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        if (type === 'checkbox' && Array.isArray(formData[name])) {
            // It's a multi-checkbox field
            setFormData(prev => ({
                ...prev,
                [name]: checked
                    ? [...prev[name], value] // add value
                    : prev[name].filter(v => v !== value) // remove value
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };
    
        const validateForm = () => {
            const newErrors = {};
            if (!formData.title.trim()) {
                newErrors.title = "Title is required.";
            }
            return newErrors;
        };
         const inputStyle = {
  title: {
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
 
 };
 
const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validateForm();
  setErrors(validationErrors);
  setViewChanges(false);
  setPreviewFields(false);
  const finalBody = cleanHtmlOutput(formData.body);
  
  setDisabled(true);
  setButtonText("Save"); 
  if (Object.keys(validationErrors).length === 0) {
     const postData = new FormData();
        const updatedFormData = {
            ...formData,
           body: finalBody,
           id:id
        };
          if (selectedPreviewImage && selectedPreviewImage.file) {
           postData.append('field_blog_preview_image', selectedPreviewImage.file);
        }
          if (selectedBannerImage && selectedBannerImage.file) {
           postData.append('field_blog_banner_image', selectedBannerImage.file);
        }
        
        postData.append('formData', JSON.stringify(updatedFormData));
         const response = await fetch(app_url+'smwwblog/editblog', {
            method: 'POST',
            body: postData,
        });
        const data = await response.json();
      if(data.data.msg == "Success") {  
        setButtonText("Save");
        setDisabled(false);
      
        navigate("/blog-content/"+slug, { state: { message: data.data.result } });
      } 
    // setSavedData(updatedFormData);
    // alert("Changes saved successfully!");
    console.log("Submitted data:", updatedFormData);
  }
};

   const handleDelete = async () => {
  if (window.confirm("Are you sure you want to delete?")) {
    const response = await fetch(
        app_url+''+id,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            navigate('/content', { state: { message: responsedata.data.result } });
           
        }
  }
};
    return(
         <>
            {isLoading ? (
                <Loading />
            ) : (
        <div id="main" className={` ${toggle === 2 ? "edit-blog-main" : "smww-agency-news-content-main"}`}>
             <Helmet>
                <title>
                    {getPageTitle()}
                </title>
            </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                  <>
                    <h1 className="edit-task-title">{getPageHeading()}</h1>
                  </>
                <>
                  {( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                    <ul className="tabs primarya">
                      <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                        <a style={{cursor: "pointer"}}>View</a>
                      </li>
                    
                      <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                        <a style={{cursor: "pointer"}}>Edit</a>
                      </li>
                      {/* )} */}
                    </ul>
                  }
                </>
                        <div  className= {toggle === 1? "show-content" : "content"}>
                            <AgencyNewsContent />
                        </div>

{( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                       <div  className= {toggle === 2? "show-content" : "content"}>
                         {viewChanges && (
<div className='diff-table-wrapper'>
  <table className="diff-table">
  <colgroup>
    <col className="diff-marker" />
    <col className="diff-content" />
    <col className="diff-marker" />
    <col className="diff-content" />
  </colgroup>
  <thead>
    <tr>
      <th colSpan="2">Original</th>
      <th colSpan="2">Changes</th>
    </tr>
  </thead>
  <tbody>
    {!formDataSnapshot || !originalData ? (
      <tr className="no-changes">
        <td className="diff-section-title" colSpan="4">No visible changes</td>
      </tr>
    ) : (
      (() => {
        const diffs = [];

    
        const compareField = (label, oldValue = '', newValue = '') => {
  if (oldValue === newValue) return null;

  const oldLines = (oldValue ?? '').split('\n');
  const newLines = (newValue ?? '').split('\n');
  const maxLines = Math.max(oldLines.length, newLines.length);

  const rows = [
    <tr className="diff-section-title" key={`${label}-title`}>
      <td colSpan="4">Changes to <em>{label}</em></td>
    </tr>
  ];

  for (let i = 0; i < maxLines; i++) {
    const oldLine = (oldLines[i] || '').trim();
    const newLine = (newLines[i] || '').trim();

    if (oldLine !== newLine) {
      const oldWords = oldLine.split(/\s+/);
      const newWords = newLine.split(/\s+/);
      const maxWords = Math.max(oldWords.length, newWords.length);

      const renderWords = (wordsA, wordsB, isOld) =>
        wordsA.map((word, idx) => {
          const matchingWord = wordsB[idx] || '';
          const changed = word !== matchingWord;

          return (
            <span
              key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
              style={changed ? {
                color: isOld ? 'red' : 'red',
                borderRadius: '4px',
                padding: '0 3px',
                fontWeight:'bold'
              } : {}}
            >
              {word}
              {' '}
            </span>
          );
        });

      rows.push(
        <tr key={`${label}-${i}`}>
          <td style={{width:"2px"}}><span>-</span></td>
          <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
          <td style={{width:"2px"}}><span>+</span></td>
          <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
        </tr>
      );
    }
  }

  return rows;
};

// const compareFiles = (label, oldFiles = [], newFiles = []) => {
//   const oldList = oldFiles.map(f => f.name).join(', ');
//   const newList = newFiles.map(f => f.name).join(', ');

//   if (oldList !== newList) {
//     return [`${label} changed: ${oldList} → ${newList}`];
//   }

//   return [];
// };
const compareFiles = (label, oldFiles = [], newFiles = []) => {
  const oldList = Array.isArray(oldFiles)
    ? oldFiles.map(f => f.name).join(', ')
    : '';

  const newList = Array.isArray(newFiles)
    ? newFiles.map(f => f.name).join(', ')
    : '';

  // If no difference, return an empty array (safe + iterable)
  if (oldList === newList) {
    return [];
  }
  // Otherwise return whatever diff UI compareField creates
  return [compareField(label, oldList, newList)];
};


        diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));      
        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));
        // diffs.push(...(compareField('File Attachments', originalData.field_file_attachments, formDataSnapshot.field_file_attachments) || []));
//         diffs.push(...compareFiles(
//   'File Attachments',
//   originalData.field_file_attachments,
//   formDataSnapshot.field_file_attachments
// ));
        diffs.push(...(compareField('Meta Title', originalData.field_meta_title, formDataSnapshot.field_meta_title) || []));
        diffs.push(...(compareField('Meta Keywords', originalData.field_meta_keywords, formDataSnapshot.field_meta_keywords) || []));
        diffs.push(...(compareField('Meta Description', originalData.field_meta_description, formDataSnapshot.field_meta_description) || []));  
        diffs.push(...(compareField('Preview Text', originalData.field_blog_preview_text, formDataSnapshot.field_blog_preview_text) || []));
              if (originalData.field_blog_preview_image !== formDataSnapshot.field_blog_preview_image) {
          diffs.push(
            <tr className="diff-section-title" key="preview-image-title">
              <td colSpan="4">Changes to <em>Preview Image</em></td>
            </tr>,
            <tr key="preview-image-diff">
              <td><span>-</span></td>
              <td className="diff-removed">
                {originalData.field_blog_preview_image && getFileName(originalData.field_blog_preview_image)}
              </td>
              <td><span>+</span></td>
              <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                {formDataSnapshot.field_blog_preview_image && getFileName(formDataSnapshot.field_blog_preview_image)}
              </td>
            </tr>
          );
        }
        if (originalData.field_blog_banner_image !== formDataSnapshot.field_blog_banner_image) {
          diffs.push(
            <tr className="diff-section-title" key="banner-image-title">
              <td colSpan="4">Changes to <em>Banner Image</em></td>
            </tr>,
            <tr key="banner-image-diff">
              <td><span>-</span></td>
              <td className="diff-removed">
                {originalData.field_blog_banner_image && getFileName(originalData.field_blog_banner_image)}
              </td>
              <td><span>+</span></td>
              <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                {formDataSnapshot.field_blog_banner_image && getFileName(formDataSnapshot.field_blog_banner_image)}
              </td>
            </tr>
          );
        }

          diffs.push(...(compareField('Author', originalData.field_blog_author, formDataSnapshot.field_blog_author) || []));
          diffs.push(...(compareField('Author Link', originalData.field_blog_author_link, formDataSnapshot.field_blog_author_link) || []));
          diffs.push(
              ...(compareField(
              'URL Restriction',
              normalizeArray(getLabels(originalData.field_url_restriction)),
              normalizeArray(getLabels(formDataSnapshot.field_url_restriction))
            ) || [])
          );
            
  
          

        return diffs.length > 0 ? diffs : (
          <tr className="no-changes">
            <td className="diff-section-title" colSpan="4">No visible changes</td>
          </tr>
        );
      })()
    )}
  </tbody>
</table>
</div>
)}
{PreviewFields && (
  <>
    <div
      className="messages status"
      style={{
        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
        backgroundPosition: '10px 10px',
      }}
    >
      The trimmed version of your post shows what your post looks like when promoted
      to the main page or when exported for syndication.
      <span>
        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
        fine-tune where your post gets split.
      </span>
    </div>

    <div className="preview-container">
      {/* Trimmed version */}
      <div className="preview-trimmed">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview trimmed version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            <a href={"/content"}>{previewData?.title}</a>
          </h2>

          {/* <div className="email-teaser-block1">
            <div className="email-teaser-block2"> */}
              {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
  <div
    className="preview-body-content"
    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
  />
              )}
            {/* </div>
          </div> */}

          <div className="read-more-link">
            <a href={"/content"}>Read more</a>
          </div>
        </div>
      </div>

      {/* Full version */}
      <div className="preview-full">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview full version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            {/* <strong>Body:</strong> */}
          </h2>

          {/* <div className="email-teaser-block1"> */}
            {/* <div className="email-teaser-block2"> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: previewData.body || '',
                }}
              />
              <div className="email-meta">
  

   {previewData.field_meta_title && (
  <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
   {previewData.field_meta_keywords && (
  <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
   {previewData.field_meta_description && (
  <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}
   {previewData.field_blog_preview_image && (
        <div>
          <strong>Preview Image:</strong><br />
          <img 
            src={getImageSrc(previewData.field_blog_preview_image.url)} 
            alt="Preview" 
            style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
          />
        </div>
      )}
       {previewData.field_blog_banner_image && (
          <div>
            <strong>Banner Image:</strong><br />
            <img 
              src={getImageSrc(previewData.field_blog_banner_image.url)} 
              alt="Preview" 
              style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
            />
          </div>
        )}
         {previewData.field_blog_author && (
        <p><strong>Author:</strong> {previewData.field_blog_author}</p>)}
        {previewData.field_blog_author_link && (
        <p><strong>Author Link:</strong> {previewData.field_blog_author_link}</p>)}
 {/* {previewData?.field_url_restriction?.length > 0 && (
  <p>
    <strong>Url Restriction:</strong> {previewData.field_url_restriction.join(', ')}
  </p>
)} */}

      {previewData.field_url_restriction && (
        <p>
          <strong>URL Restriction:</strong>{" "}
          {urlRestriction.filter(opt => previewData.field_url_restriction.includes(opt.value)).map(opt => opt.label).join(", ")}
        </p>
      )}

</div>

            {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  </>
)}
                <div className="edit-blog-container">
                             {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className="form-item">
                                <label htmlFor="create-agent-message-title">
                                    Title  
                                    <span className="form-required" title="This field is required.*">*</span>
                                </label>
                                <input 
                                    className="create-agent-message-title-field" 
                                    type="text" 
                                    id="create-agent-message-title" 
                                    name="title" 
                                    maxLength={100}
                                    onChange={handleChange} 
                                     value={formData.title}
                                    style={inputStyle.title}
                            
                                />
                                    {/* {errors.title && (
                                    <div className="form-error">{errors.title}</div>
                                )} */}
                            </div>
                            <div className="">
                                <div>
                                    {showSummary && (
                                        <div className="form-item">
                                            <label htmlFor="create_summary">
                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                            </label>
                                            <>
                                                <>
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.summary} 
                                                        // onChange={e => onEditorChange('summary', e.target.value)} 
                                                        onChange={value => onEditorChange('summary', value)}
                                                    />
                                                </>
                                            </>
                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                        </div>
                                    )}
                            
                                    <div className="form-item">
                                        <label htmlFor="create_body">
                                            Body 
                                            {!showSummary && (
                                                <span>
                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                        Edit Summary
                                                    </a>)
                                                </span>
                                            )}
                                        </label>
                                        <>
                                            {useRichEditor ? (
                                                <> 
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)}
                                                        // onChange={value => onEditorChange('body', value)}
                                                         onChange={handleEditorChange}

                                                    />  
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                        Switch to plain text editor
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <textarea
                                                        id="create_body"
                                                        rows="20"
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)} 
                                                        onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) }
                                                    />
                                                    <div 
                                                        className="grippie" 
                                                        style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                    >
                                                    </div>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                        Switch to rich text editor
                                                    </a>
                                                </>
                                            )}
                                        </>
                                    </div>
                                   
                                     </div>
                                     </div>
                 <div className="form-item -field-meta-title">
          <label htmlFor="meta_title">Meta Title</label>
          <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
           onChange={handleChange}  
        /> 
      </div>
      <div className="form-item field-meta-keywords">
          <label htmlFor="meta_keywords">Meta Keywords</label>
          <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
             onChange={handleChange}
          /> 
      </div>
              <div className="form-item  fieldmeta-description">
          <label>Meta Description</label>
          <textarea
            name="field_meta_description"
            value={formData.field_meta_description}
            onChange={handleChange}
            
          />
                                <div className="grippie" style={{
    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
  }}>   
  </div>

        </div>
           <div className="form-item  fieldmeta-description">
          <label>Preview Text </label>
          <textarea
            name="field_blog_preview_text"
            value={formData.field_blog_preview_text}
            onChange={handleChange}
            
          />
                                <div className="grippie" style={{
    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
  }}>   
  </div>

        </div>
        
                       <div>
                        {imageUploadErrorPreview && (
                          <div 
                            className="set-message-error error-message-padding"
                            style={{
                              background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                            >
                              <div 
                              style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px',
                                marginLeft:'30px'                                 
                              }}
                            dangerouslySetInnerHTML={{ __html: imageUploadErrorPreview }}
                          >                            
                          </div>
                          </div>
                        )}
                        <div>
                          <label>Preview Image </label>
                          {selectedPreviewImage ? (
                            // Case 1: New image selected
                            <>
                              <div className="edit-agent-image-container">
                                <img alt="Uploaded" src={selectedPreviewImage.preview} style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}} />
                                <div className="image-info">
                                  <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(previewFileName)}
                                />
                                  <a
                                    href={selectedPreviewImage.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {previewFileName}
                                  </a>
                                  <span className="image-size">
                                    ({(selectedPreviewImage.file.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSelectedImage('preview')}
                              />
                            </>
                          ) : formData.field_blog_preview_image ? (
                            // Case 2: Image already saved (URL string from backend)
                            <>
                              <div className="edit-scout-report-image-container">
                                <img
                                  alt="Uploaded"
                                  src={formData.field_blog_preview_image?.url}
                                  style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}}
                                />
                                <div className="image-info">
                                <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(formData.field_blog_preview_image?.name)}
                                  width="16"
                                  height="16"
                                />
                                  <a
                                    href={formData.field_blog_preview_image?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {previewFileName}
                                  </a>
                                  <span className="image-size">
                                    ({(uploadedPreviewImage.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSavedImage('preview')}
                              />
                            </>
                          ) : (
                            // Case 3: No image yet → show upload input
                            <div>
                              <input
                                type="file"
                                id="edit-agent-photo-upload"
                                name="edit_agent_photo_upload"
                                accept="image/*"
                                onChange={(e) => handleTempImageChange(e, 'preview')}
                              />
                              <input
                                type="button"
                                value="Upload"
                                className="form-submit"
                                // onClick={() =>
                                //   document.getElementById("edit-agent-photo-upload").click()
                                // }
                                onClick={() => handleImageUploadClick('preview')}
                              />
                            </div>
                          )}

                          {!formData.field_blog_preview_image && !selectedPreviewImage && (
                            <div className="description" style={{fontSize:"12px"}}>
                              Image size must be 448*220 px<br/>
                              Files must be less than <b>128 MB</b>.<br />
                              Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                          )}
                        </div>
                      </div>    
                      <div style={{clear:"both"}}></div>      
                               <div>
                        {imageUploadErrorBanner && (
                          <div 
                            className="set-message-error error-message-padding"
                            style={{
                              background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                            >
                              <div 
                              style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px',
                                marginLeft:'30px'                                 
                              }}
                            dangerouslySetInnerHTML={{ __html: imageUploadErrorBanner }}
                          >                            
                          </div>
                          </div>
                        )}
                        <div>
                          <label>Banner Image </label>
                          {selectedBannerImage ? (
                            // Case 1: New image selected
                            <>
                              <div className="edit-agent-image-container">
                                <img alt="Uploaded" src={selectedBannerImage.preview} style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}} />
                                <div className="image-info">
                                  <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(bannerFileName)}
                                />
                                  <a
                                    href={selectedBannerImage.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {bannerFileName}
                                  </a>
                                  <span className="image-size">
                                    ({(selectedBannerImage.file.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSelectedImage('banner')}
                              />
                            </>
                          ) : formData.field_blog_banner_image ? (
                            // Case 2: Image already saved (URL string from backend)
                            <>
                              <div className="edit-scout-report-image-container">
                                <img
                                  alt="Uploaded"
                                  src={formData.field_blog_banner_image?.url}
                                  style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}}
                                />
                                <div className="image-info">
                                <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(formData.field_blog_banner_image?.name)}
                                  width="16"
                                  height="16"
                                />
                                  <a
                                    href={formData.field_blog_banner_image?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {bannerFileName}
                                  </a>
                                  <span className="image-size">
                                    ({(uploadedBannerImage.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSavedImage('banner')}
                              />
                            </>
                          ) : (
                            // Case 3: No image yet → show upload input
                            <div>
                              <input
                                type="file"
                                id="edit-agent-photo-upload"
                                name="edit_agent_photo_upload"
                                accept="image/*"
                                onChange={(e) => handleTempImageChange(e, 'banner')}
                              />
                              <input
                                type="button"
                                value="Upload"
                                className="form-submit"
                                // onClick={() =>
                                //   document.getElementById("edit-agent-photo-upload").click()
                                // }
                                onClick={() => handleImageUploadClick('banner')}
                              />
                            </div>
                          )}

                          {/* {(selectedImage || formData.field_scout_report_image) && (
                            <input
                              type="button"
                              value="Remove"
                              className="form-submit"
                              onClick={removeImage}
                            />
                          )} */}

                          {!formData.field_scout_report_image && !selectedBannerImage && (
                            <div className="description" style={{fontSize:"12px"}}>
                              Image size must be a minimum of 850*439 px or a maximum of 1120*553 px<br/>
                              Files must be less than <b>128 MB</b>.<br />
                              Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{clear:"both"}}></div>
                      <div class="form-item">
                          <label for="edit-field-blog-author-und-0-value">Author </label>
                        <input class="text-full form-text" type="text" id="edit-field-blog-author-und-0-value" name="field_blog_author" value={formData.field_blog_author} size="60" maxLength="255" onChange={handleChange}/>
                        </div>
                        <div class="form-item">
                          <label for="edit-field-blog-author-link-und-0-value">Author Link </label>
                        <input class="text-full form-text" type="text" id="edit-field-blog-author-link-und-0-value" name="field_blog_author_link" value={formData.field_blog_author_link} size="60" maxLength="300" onChange={handleChange}/>
                        </div>
                         <div className="">
                                    <label>URL Restriction</label>
                                    <div>
                                        {urlRestriction.map((url) => (
                                        <label key={url.value} style={{ fontWeight: 'normal', lineHeight: '2' }}>
                                            <input
                                            type="checkbox"
                                            name="field_url_restriction"
                                            value={url.value}
                                            checked={formData.field_url_restriction.includes(url.value)}
                                            onChange={handleChange}
                                            />
                                            {url.label}
                                        </label>
                                        ))}
                                    </div>
                                    </div>
                            <div className="form-actions form-wrapper" id="create-actions">
                                {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                                <button type="submit" className="form-submit" disabled={disabled}>{buttontext}</button>&nbsp;&nbsp;
                               <input 
                                          type="button" 
                                          id="edit-preview"  
                                          value="Preview" 
                                          className="form-submit" 
                                          onClick={()=> {
                                          handlePreviewClick();
                                          // window.scrollTo({ top: 0, behavior: 'smooth' });
                                          }}
                                        />&nbsp;&nbsp;
                                        <input
                                          type="button"
                                          id="edit-task-preview-changes"
                                          value="View changes"
                                          className="form-submit"
                                          onClick={handleViewChangesClick}
                                        />&nbsp;&nbsp;

                                        <input type="button" id="edit-task-delete" name="" value="Delete" className="form-submit" onClick={handleDelete} />
                            </div>
                        </div>
                    </form>

                </div>
                </div>
}
            </div>
            <div className="right">
              <div  className= {toggle === 2? "show-content" : "content"}>
                <SalespersonSidebar/> 
              </div>             
            </div>
        </div>
            )}
            </>
    );
};
export default EditBlog;